import { render, staticRenderFns } from "./FrameCheckAutorizzazioni.vue?vue&type=template&id=4a5527c8&scoped=true&"
import script from "./FrameCheckAutorizzazioni.vue?vue&type=script&lang=js&"
export * from "./FrameCheckAutorizzazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5527c8",
  null
  
)

export default component.exports